module.exports = __webpack_public_path__ + "static/img/06-qmysgly.81076712.png";